<div class="despacho-container">
    <div *ngIf="loading" class="loading-overlay">
        <div class="spinner"></div>
        <p>Cargando datos...</p>
    </div>

    <div *ngIf="error" class="error-message">
        <p>{{ error }}</p>
        <button (click)="error = null" class="btn-close">&times;</button>
    </div>

    <div class="header-panel">
        <div class="filtros">
            <div class="filtro-item">
                <label for="coordinador">Coordinador</label>
                <select id="coordinador" [value]="coordinadorSeleccionado || ''" (change)="cambiarCoordinador($event)" [disabled]="loading || reportLoading">
                    <option value="" disabled>Seleccione un coordinador</option>
                    <option *ngFor="let coord of coordinadores" [value]="coord.id">
                        {{ coord.nombre }}
                    </option>
                </select>
            </div>
            <div class="filtro-item">
                <label for="year">A&ntilde;o</label>
                <div class="input-year-wrapper">
                    <input type="text" id="year" [value]="year" readonly />
                    <div class="year-controls">
                        <button [disabled]="loading || reportLoading" (click)="cambiarYear(1)" class="btn-small">&#9650;</button>
                        <button [disabled]="loading || reportLoading" (click)="cambiarYear(-1)" class="btn-small">&#9660;</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="actions-panel">
            <button class="btn-action generate-report"
                    type="button"
                    [disabled]="loading || reportLoading"
                    [matMenuTriggerFor]="reportMenu">
                <mat-icon class="action-icon" aria-hidden="true">download</mat-icon>
                <span>Generar Informe</span>
            </button>
            <mat-menu #reportMenu="matMenu" xPosition="before">
                <button mat-menu-item
                        type="button"
                        [disabled]="reportLoading || !visitaSeleccionadaId"
                        (click)="generarInformeWord()">
                    Seleccionado
                </button>
                <button mat-menu-item
                        type="button"
                        [disabled]="reportLoading || !coordinadorNombre"
                        (click)="generarInformeExcel()">
                    Tabla (Excel)
                </button>
                <button mat-menu-item
                        type="button"
                        [disabled]="reportLoading || !coordinadorNombre"
                        (click)="abrirInformeRango()">
                    Varios (entre fechas)
                </button>
            </mat-menu>
        </div>
    </div>

    <div class="tabs">
        <div class="tab-label consulta active">Consulta</div>
    </div>

    <div class="tabla-container">
        <table class="tabla-visitas">
            <colgroup>
                <col class="col-empresa">
                <col *ngFor="let month of months" class="col-month">
            </colgroup>
            <thead>
                <tr>
                    <th class="col-empresa">Empresa</th>
                    <th *ngFor="let month of months">{{ month }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let empresa of empresas"
                    [ngClass]="{'selected': empresaSeleccionado === empresa.empresaId}"
                    (click)="seleccionarEmpresa(empresa)">
                    <td class="col-empresa">
                        <div>{{ empresa.nombre }}</div>
                    </td>
                    <td *ngFor="let month of months"
                        [ngClass]="{'has-visits': empresa.visitas[month]?.length}">
                        <button *ngFor="let visita of empresa.visitas[month]"
                                type="button"
                                class="fecha-button"
                                [class.visita-realizada]="visita.realizada"
                                [class.selected-date]="visitaSeleccionadaId === visita.id"
                                [title]="visita.fechaCompleta"
                                (click)="seleccionarVisita(empresa, visita, $event)">
                            {{ visita.fecha }}
                        </button>
                    </td>
                </tr>
                <tr *ngIf="empresas.length === 0 && !loading">
                    <td [attr.colspan]="months.length + 1" class="no-data">
                        No hay datos disponibles para el coordinador y a&ntilde;o seleccionados
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="footer-panel">
        <div class="footer-layout">
            <div class="visitas-column">
                <div class="visitas-info">
                    <span>Visitas:</span>
                    <div class="visita-status">
                        <span>Realizada</span>
                        <div class="status-indicator realizada"></div>
                    </div>
                    <div class="visita-status">
                        <span>Pendiente</span>
                        <div class="status-indicator pendiente"></div>
                    </div>
                </div>

                <div class="selected-visits-box">
                    <div class="selected-visits-header">Fechas</div>
                    <ng-container *ngIf="getEmpresaSeleccionada() as selectedEmpresa; else emptyVisits">
                        <button *ngFor="let visita of selectedEmpresa.visitasOrdenadas"
                                type="button"
                                class="selected-visit-item"
                                [class.active]="visitaSeleccionadaId === visita.id"
                                [class.pending]="!visita.realizada"
                                (click)="seleccionarVisita(selectedEmpresa, visita, $event)">
                            {{ visita.fechaCompleta || visita.fecha }}
                        </button>
                        <div *ngIf="selectedEmpresa.visitasOrdenadas.length === 0" class="selected-visit-empty">
                            Sin visitas
                        </div>
                    </ng-container>
                    <ng-template #emptyVisits>
                        <div class="selected-visit-empty">Sin visitas</div>
                    </ng-template>
                </div>
            </div>

            <div class="detail-column">
                <div class="detail-row">
                    <div class="detail-field short">
                        <label for="fechaVisitaDetalle">Fecha Visita:</label>
                        <input id="fechaVisitaDetalle" type="text" [value]="fechaVisitaDetalle" readonly />
                    </div>
                    <div class="detail-field">
                        <label for="coordinadorDetalle">Coordinador:</label>
                        <input id="coordinadorDetalle" type="text" [value]="coordinadorDetalle" readonly />
                    </div>
                </div>

                <div class="detail-row">
                    <div class="detail-field short">
                        <label for="tipoDetalle">Tipo:</label>
                        <input id="tipoDetalle" type="text" [value]="tipoDetalle" readonly />
                    </div>
                    <div class="detail-field">
                        <label for="asuntoDetalle">Asunto:</label>
                        <input id="asuntoDetalle" type="text" [value]="asuntoDetalle" readonly />
                    </div>
                </div>

                <div class="detail-row full">
                    <div class="detail-field">
                        <label for="asistentesDetalle">Asistentes:</label>
                        <input id="asistentesDetalle" type="text" [value]="asistentesDetalle" readonly />
                    </div>
                </div>

                <div class="detail-row full">
                    <div class="detail-field">
                        <label for="asistentesEmpresaDetalle">Asistentes Empresa:</label>
                        <input id="asistentesEmpresaDetalle" type="text" [value]="asistentesEmpresaDetalle" readonly />
                    </div>
                </div>

                <div class="detail-row full">
                    <div class="detail-field">
                        <label for="asistentesMutuaDetalle">Asistentes Mutua:</label>
                        <input id="asistentesMutuaDetalle" type="text" [value]="asistentesMutuaDetalle" readonly />
                    </div>
                </div>

                <div class="detail-row full text-panels">
                    <div class="text-panel">
                        <label for="resumenDetalle">Resumen</label>
                        <textarea id="resumenDetalle"
                                  [value]="resumenDetalle"
                                  readonly
                                  rows="5"
                                  placeholder="Resumen"></textarea>
                    </div>
                    <div class="text-panel">
                        <label for="comentariosDetalle">Descripci&oacute;n de la visita</label>
                        <textarea id="comentariosDetalle"
                                  [value]="comentariosDetalle"
                                  readonly
                                  rows="5"
                                  placeholder="Comentarios"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
